import { Dispatch, ReactNode, SetStateAction, useCallback } from "react";
import { FlexCoulmn, FlexRow } from "../styles/globalsStyles";
import { Button } from "./core/Button";
import { usePopover } from "../hooks/usePopover";

interface AreYouSurePromptProps {
  children: ReactNode;
  setAnswer:
    | Dispatch<SetStateAction<boolean>>
    | Dispatch<SetStateAction<boolean | null>>;
  notInPopover?: boolean;
}
const AreYouSurePrompt = ({
  children,
  setAnswer,
  notInPopover
}: AreYouSurePromptProps) => {
  const { hidePopover } = usePopover();

  const handleClick = useCallback(
    (answer: boolean) => {
      setAnswer(answer);
      if (!notInPopover) return;
      hidePopover();
    },
    [hidePopover, notInPopover, setAnswer]
  );

  return (
    <FlexCoulmn
      $justifyContent="center"
      $alignItems="center"
      $height={"215px"}
      $gap={"1rem"}
    >
      {children}
      <FlexRow $gap={"1rem"}>
        <Button onClick={() => handleClick(true)}>כן</Button>
        <Button onClick={() => handleClick(false)}>לא</Button>
      </FlexRow>
    </FlexCoulmn>
  );
};

export default AreYouSurePrompt;
